import React, { Component } from "react";
import { connect } from "react-redux";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardContent,
    Grid,
    Button,
    TextField,
    Select,
    MenuItem,
    Typography,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import PrintIcon from "@material-ui/icons/Print";
import EmailIcon from "@material-ui/icons/Email";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import MapIcon from "@material-ui/icons/Map";
import PhoneIcon from "@material-ui/icons/Phone";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle as gstyle, cellStyle as cstyle } from "../gridHelper";

import MapContainerVehicleChecklist from "../MapContainerVehicleChecklist";
import checks from "./checks.json";
import insidechecks from "./insidechecks.json";
import { noSig } from "vrcore-dashboard/dist/utilities";
import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import "../reports.css";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styled from "styled-components";

// import { cellStyle as cs } from "../gridHelper";
// import { cellStyle as cstyle } from "../gridHelper";
let offlineReference1 = "";
let offlineReference2 = "";
let offlineReference3 = "";
const ActionButton = styled(Button)`
    @media print {
        visibility: collapse;
    }
`;
const Print = styled.div`
    @media print {
        margin: 0;
        padding: 0;
        width: 100%;
    }
`;
let checkedit = "";
class VehicleChecklist extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];
        if (path[2] === "reports") {
            this.state = {
                imageModal: false,
                report: false,
                editing:
                    path[1] === "report-view"
                        ? false
                        : path[1] === "report-view-standalone"
                        ? false
                        : true,
                title: document.title,
            };
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":")
            );
        } else {
            this.state = {
                imageModal: false,
                report: false,
                editing:
                    path[1] === "report-view"
                        ? false
                        : path[1] === "report-view-standalone"
                        ? false
                        : true,
                title: document.title,
            };
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }
    renderCheckRow(check, checkRowCount) {
        let row = [];
        let rT = this.renderText;
        let rStatus = this.renderInspection;
        row.push(
            <React.Fragment key={checkRowCount}>
                <div style={cstyle(checkRowCount, 2, checkRowCount, 2, true)}>
                    <b className="customStatusTextStyle" style={{fontSize:"12px"}}>
                        {rStatus(
                            `${check.status}`,
                            this.props.report[check.status]
                        )}
                    </b>
                </div>
                <div style={cstyle(checkRowCount, 3, checkRowCount, 3, true)}>
                    <b className="customDefectTextStyle" style={{fontSize:"12px",wordBreak:"break-all"}}>
                        {rT(`${check.defect}`, this.props.report[check.defect])}
                    </b>
                </div>
                <div style={cstyle(checkRowCount, 4, checkRowCount, 4, true)}>
                    <b className="customTempFixTextStyle" style={{fontSize:"12px",wordBreak:"break-all"}}>
                        {rT(
                            `${check.temp_fix}`,
                            this.props.report[check.temp_fix]
                        )}
                    </b>
                </div>
            </React.Fragment>
        );

        checkRowCount++;
        return row;
    }
    renderInsideCheckRow(check, checkRowCount) {
        let row = [];
        let rT = this.renderText;
        let rStatus = this.renderInspection;
        row.push(
            <React.Fragment key={checkRowCount}>
                <div
                    style={cstyle(
                        checkRowCount - 12,
                        6,
                        checkRowCount - 12,
                        6,
                        true
                    )}
                >
                    <b className="customStatusTextStyle" style={{fontSize:"12px"}}>
                        {rStatus(
                            `${check.status}`,
                            this.props.report[check.status]
                        )}
                    </b>
                </div>
                <div
                    style={cstyle(
                        checkRowCount - 12,
                        7,
                        checkRowCount - 12,
                        7,
                        true
                    )}
                >
                    <b className="customDefectTextStyle" style={{fontSize:"12px", wordBreak:"break-all"}}>
                        {rT(`${check.defect}`, this.props.report[check.defect])}
                    </b>
                </div>
                <div
                    style={cstyle(
                        checkRowCount - 12,
                        8,
                        checkRowCount - 12,
                        8,
                        true
                    )}
                >
                    <b className="customDefectTextStyle" style={{fontSize:"12px", wordBreak:"break-all"}}>
                        {rT(
                            `${check.temp_fix}`,
                            this.props.report[check.temp_fix]
                        )}
                    </b>
                </div>
            </React.Fragment>
        );

        checkRowCount++;
        return row;
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value !== "" ? value : "N/A";
        }
    };
    renderInspection = (key, value = false) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value={"No Defect"}>No Defect</MenuItem>
                    <MenuItem value={"Un-Roadworthy"}>Un-Roadworthy</MenuItem>
                    <MenuItem value={"Temp. Fix"}>Temp. Fix</MenuItem>
                </Select>
            );
        } else {
            return value;
        }
    };

    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cstyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedImg: photo.photo_url,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url;
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div style={cstyle(sigRow, sigCell, sigRow, sigCell, true)}>
                        {sig.signature_name}
                    </div>
                    <div
                        style={cstyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:") ? (
                        <div
                            style={cstyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: sig.signature_url,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: "140px",
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cstyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: ref,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }

    render() {
        let report = this.props.report === false ? false : this.props.report;
        console.log(report,"report")
        let rT = this.renderText;
        let checkRowCount = 1;
        const color = this.props.color;
        // const buttonName = this.state.open ? "Hide" : "Show";
        return this.state.editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Block Vehicle Check Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Vehicle Checklist
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title =
                                    "Vehicle Checklist - " +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        // height:"44px",
                                        // width:"60px",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor:"pointer"
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    <Print ref={(el) => (this.componentRef = el)}>
                        {this.props.header && (
                            <this.props.header
                                date={this.props.match.params.report_id}
                                reportType={this.props.reportType}
                            />
                        )}
                        {report && (
                            <>
                                <Grid
                                    container
                                    spacing={3}
                                    style={{ width: "100%" }}
                                >
                                    <Grid item xl={3} lg={3} md={6} sm={12}>
                                        <div
                                            style={gstyle(5, 13, null, color)}
                                            ref={(ref) => (this.infoDiv = ref)}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Information</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <AccountBoxIcon />
                                                &nbsp;<b>Name:</b>&nbsp; {report.user_name}
                                            </div>
                                   
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <EmailIcon />
                                                &nbsp;<b>Email:</b>&nbsp;   {rT(
                                                    "user_email",
                                                    report.user_email
                                                )}
                                            </div>
                                       
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <PhoneIcon />
                                                &nbsp;<b>Contact:</b>&nbsp;      {rT(
                                                    "user_contact_no",
                                                    report.user_contact_no
                                                )}
                                            </div>
                                      
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <MapIcon />
                                                &nbsp;<b>GPS</b>&nbsp; {report.location_lat +
                                                        ", " +
                                                        report.location_lon}
                                            </div>
                                     
                                        </div>
                                    </Grid>

                                    <Grid item xl={3} lg={3} md={6} sm={12}>
                                        <div
                                            style={gstyle(5, 13, null, color)}
                                            ref={(ref) => (this.infoDiv = ref)}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Information</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Create:</b>&nbsp;  {report.timestamp}
                                            </div>
                                          
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Start Time:</b>&nbsp;  {report.start_timestamp}
                                            </div>
                                         
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <b>End Time: </b>&nbsp; {report.timestamp}
                                            </div>
                                       
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <b>Odometer Start: </b>&nbsp;   {rT(
                                                    "odometer_reading",
                                                    report.odometer_reading
                                                )}
                                            </div>
                                           
                                        </div>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12}>
                                        <div
                                            style={gstyle(5, 13, null, color)}
                                            ref={(ref) => (this.infoDiv = ref)}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Vehicle Details</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Registration:</b>&nbsp;  {rT(
                                                    "vehicle_reg",
                                                    report.vehicle_reg
                                                )}
                                            </div>
                                        
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Driver Name:</b>&nbsp;   {rT(
                                                    "driver_name",
                                                    report.driver_name
                                                )}
                                            </div>
                                    
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <b>Crew Name:</b>&nbsp;  {rT(
                                                    "crew_name",
                                                    report.crew_name
                                                )}
                                            </div>
                                          
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <b>Odometer End:</b>&nbsp;   {rT(
                                                    "odometer_reading_finish",
                                                    report.odometer_reading_finish
                                                )}
                                            </div>
                                        </div>
                                    </Grid>
                                    {/* <Grid item xl={3} lg={3} md={6} sm={12}> */}
                                     <div style={{ width: "22%", clear: "both", paddingTop:"10px" }}>
                                        <div style={gstyle(4, 4)}>
                                            <div
                                                style={cstyle(1, 1, 1, 2, false, true)}
                                            >
                                                <b>Location</b>
                                            </div>
                                            <MapContainerVehicleChecklist
                                                    lat={+report.location_lat}
                                                    long={+report.location_lon}
                                                    style={{
                                                        width: "50%",
                                                        height: "60px",
                                                    }}
                                                />
                                        </div>
                                    </div>
                                    {/* </Grid> */}
                                </Grid>
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(5, 4, 12.5, null)}></div>
                                </div>

                                <div style={gstyle(14, 5, 12, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Inspection</b>
                                    </div>
                                    <div
                                        style={{...cstyle(1, 2, 1, 2, false, true), marginLeft:"30px"}}
                                    >
                                        <b>Status</b>
                                    </div>
                                    <div
                                        style={{...cstyle(1, 3, 1, 3, false, true), marginLeft:"30px"}}
                                    >
                                        <b>Defect</b>
                                    </div>
                                    <div
                                        style={{...cstyle(1, 4, 1, 4, false, true), marginLeft:"24px"}}
                                    >
                                        <b>Temp Fix</b>
                                    </div>
                                    <div
                                        style={cstyle(1, 5, 1, 5, false, true)}
                                    >
                                        <b>Inspection</b>
                                    </div>
                                    <div
                                        style={{...cstyle(1, 6, 1, 6, false, true), marginLeft:"30px"}}
                                    >
                                        <b>Status</b>
                                    </div>
                                    <div
                                        style={{...cstyle(1, 7, 1, 7, false, true), marginLeft:"30px"}}
                                    >
                                        <b>Defect</b>
                                    </div>
                                    <div
                                        style={{...cstyle(1, 8, 1, 8, false, true), marginLeft:"24px"}}
                                    >
                                        <b>Temp Fix</b>
                                    </div>
                                    {Object.keys(checks).map((e) => {
                                        checkRowCount++;
                                        return this.renderCheckRow(
                                            checks[e],
                                            checkRowCount
                                        );
                                    })}
                                    {Object.keys(insidechecks).map((e) => {
                                        checkRowCount++;
                                        return this.renderInsideCheckRow(
                                            insidechecks[e],
                                            checkRowCount
                                        );
                                    })}
                                    <div style={cstyle(2, 1, 2, 1)}>
                                        <img
                                            alt={"tagicon"}
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/tax_oc.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Tax & Insurance
                                        </b>
                                    </div>
                                    <div style={cstyle(3, 1, 3, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/regplate.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Reg. Plate & Markings
                                        </b>
                                    </div>
                                    <div style={cstyle(4, 1, 4, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/airelectrial.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Air & Electrical
                                        </b>
                                    </div>
                                    <div style={cstyle(5, 1, 5, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/fluidleaks.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Fluid Levels/ Leaks
                                        </b>
                                    </div>
                                    <div style={cstyle(6, 1, 6, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/airsuspension.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Air Suspension
                                        </b>
                                    </div>
                                    <div style={cstyle(7, 1, 7, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/wheelstyres.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Wheels & Tyres
                                        </b>
                                    </div>
                                    <div style={cstyle(8, 1, 8, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/lightsreflectors.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Lights & Reflectors
                                        </b>
                                    </div>
                                    <div style={cstyle(9, 1, 9, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/exhaust.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Exhaust
                                        </b>
                                    </div>
                                    <div style={cstyle(10, 1, 10, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/bodyguards.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Body/ Guards/ Straps
                                        </b>
                                    </div>
                                    <div style={cstyle(11, 1, 11, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/landingleg.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Landing Leg
                                        </b>
                                    </div>
                                    <div style={cstyle(12, 1, 12, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/sparetow.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Spare Steps/ Tow
                                        </b>
                                    </div>
                                    <div style={cstyle(13, 1, 13, 1)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/trailerbrake.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Trailer Brake
                                        </b>
                                    </div>
                                    <div style={cstyle(2, 5, 2, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/winmiri.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Windows & Mirrors
                                        </b>
                                    </div>
                                    <div style={cstyle(3, 5, 3, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/seatbelts.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Seatbelts & Controls
                                        </b>
                                    </div>
                                    <div style={cstyle(4, 5, 4, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/washerandwiper.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Washers & Wipers
                                        </b>
                                    </div>
                                    <div style={cstyle(5, 5, 5, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/horn.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Horn
                                        </b>
                                    </div>
                                    <div style={cstyle(6, 5, 6, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/breakwarninglight.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Brake Warning Lights
                                        </b>
                                    </div>
                                    <div style={cstyle(7, 5, 7, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/gauge.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Gauge & Warning Light
                                        </b>
                                    </div>
                                    <div style={cstyle(8, 5, 8, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/tacho.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Tacho
                                        </b>
                                    </div>
                                    <div style={cstyle(9, 5, 9, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/airleaks.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Air Leaks & Pressure
                                        </b>
                                    </div>
                                    <div style={cstyle(10, 5, 10, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/steeringbreaking.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Steering & Braking
                                        </b>
                                    </div>
                                    <div style={cstyle(11, 5, 11, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/loadsecure.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Load Secure/ Balance
                                        </b>
                                    </div>
                                    <div style={cstyle(12, 5, 12, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/tachospeedo.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            Tacho & Speed Limiter
                                        </b>
                                    </div>
                                    <div style={cstyle(13, 5, 13, 5)}>
                                        <img
                                            alt="tagicon"
                                            style={{height:"32px" , width:"32px"}}
                                            className="customNameImgStyle"
                                            src={require("./icons/nowarninglights.png")}
                                        />
                                        &nbsp;
                                        <b className="customNameTextStyle" style={{fontSize:"12px"}}>
                                            No Warning Lights
                                        </b>
                                    </div>
                                </div>

                                <br />
                                {typeof report.sig_1_url !== "undefined" ? (
                                    <>
                                        <div
                                            style={{
                                                marginTop: "20px",
                                                width: "100%",
                                                clear: "both",
                                                height: 400,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "45%",
                                                    float: "left",
                                                }}
                                            >
                                                <div
                                                    style={gstyle(
                                                        7,
                                                        7,
                                                        null,
                                                        color
                                                    )}
                                                >
                                                    <div
                                                        style={cstyle(
                                                            1,
                                                            1,
                                                            1,
                                                            7,
                                                            false,
                                                            true
                                                        )}
                                                    >
                                                        <b className="customTableHeaderStyle">
                                                            Signatures (User &
                                                            Visitor)
                                                        </b>
                                                    </div>

                                                    <div
                                                        style={cstyle(
                                                            2,
                                                            1,
                                                            4,
                                                            3
                                                        )}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "none",
                                                            }}
                                                        >
                                                            {report.sig_1_url.includes(
                                                                "https:"
                                                            )
                                                                ? ""
                                                                : (offlineReference1 =
                                                                      "data:image/png;base64," +
                                                                      report.sig_1_url)}
                                                        </div>
                                                        {report.sig_1_url.includes(
                                                            "https:"
                                                        ) ? (
                                                            <img
                                                                style={{
                                                                    width:
                                                                        "60%",
                                                                    height:
                                                                        "auto",
                                                                    margin:
                                                                        "auto",
                                                                }}
                                                                src={
                                                                    report.sig_1_url ===
                                                                        undefined ||
                                                                    report.sig_1_url ===
                                                                        null ||
                                                                    report.sig_1_url ===
                                                                        ""
                                                                        ? noSig
                                                                        : report.sig_1_url
                                                                }
                                                                alt="No Signature Available"
                                                            />
                                                        ) : (
                                                            <img
                                                                style={{
                                                                    width:
                                                                        "60%",
                                                                    height:
                                                                        "auto",
                                                                    margin:
                                                                        "auto",
                                                                }}
                                                                src={
                                                                    report.sig_1_url ===
                                                                        undefined ||
                                                                    report.sig_1_url ===
                                                                        null ||
                                                                    report.sig_1_url ===
                                                                        ""
                                                                        ? noSig
                                                                        : offlineReference1
                                                                }
                                                                alt="No Signature Available"
                                                            />
                                                        )}
                                                    </div>

                                                    <div
                                                        style={cstyle(
                                                            2,
                                                            3,
                                                            4,
                                                            7
                                                        )}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "none",
                                                            }}
                                                        >
                                                            {report.sig_2_url.includes(
                                                                "https:"
                                                            )
                                                                ? ""
                                                                : (offlineReference2 =
                                                                      "data:image/png;base64," +
                                                                      report.sig_1_url)}
                                                        </div>
                                                        {report.sig_2_url.includes(
                                                            "https:"
                                                        ) ? (
                                                            <img
                                                                style={{
                                                                    width:
                                                                        "60%",
                                                                    height:
                                                                        "auto",
                                                                    margin:
                                                                        "auto",
                                                                }}
                                                                src={
                                                                    report.sig_2_url ===
                                                                        undefined ||
                                                                    report.sig_2_url ===
                                                                        null ||
                                                                    report.sig_2_url ===
                                                                        ""
                                                                        ? noSig
                                                                        : report.sig_2_url
                                                                }
                                                                alt="No Signature Available"
                                                            />
                                                        ) : (
                                                            <img
                                                                style={{
                                                                    width:
                                                                        "60%",
                                                                    height:
                                                                        "auto",
                                                                    margin:
                                                                        "auto",
                                                                }}
                                                                src={
                                                                    report.sig_2_url ===
                                                                        undefined ||
                                                                    report.sig_2_url ===
                                                                        null ||
                                                                    report.sig_2_url ===
                                                                        ""
                                                                        ? noSig
                                                                        : offlineReference2
                                                                }
                                                                alt="No Signature Available"
                                                            />
                                                        )}
                                                    </div>

                                                    <div
                                                        style={cstyle(
                                                            5,
                                                            1,
                                                            5,
                                                            7
                                                        )}
                                                    >
                                                        <b>Inspector Name:</b>
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            5,
                                                            4,
                                                            5,
                                                            7,
                                                            true
                                                        )}
                                                    >
                                                        {report.sig_1_name}
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            6,
                                                            1,
                                                            6,
                                                            7
                                                        )}
                                                    >
                                                        <b>Visitor Name:</b>
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            6,
                                                            4,
                                                            6,
                                                            7,
                                                            true
                                                        )}
                                                    >
                                                        {report.sig_2_name}
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            7,
                                                            1,
                                                            7,
                                                            7
                                                        )}
                                                    >
                                                        <b>User Timestamp:</b>
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            7,
                                                            4,
                                                            7,
                                                            7,
                                                            true
                                                        )}
                                                    >
                                                        {report.sig_1_timestamp}
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            8,
                                                            1,
                                                            8,
                                                            7
                                                        )}
                                                    >
                                                        <b>
                                                            Visitor Timestamp:
                                                        </b>
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            8,
                                                            4,
                                                            8,
                                                            7,
                                                            true
                                                        )}
                                                    >
                                                        {report.sig_2_timestamp}
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    width: "45%",
                                                    float: "right",
                                                }}
                                            >
                                                <div
                                                    style={gstyle(
                                                        7,
                                                        2,
                                                        null,
                                                        color
                                                    )}
                                                >
                                                    <div
                                                        style={cstyle(
                                                            1,
                                                            1,
                                                            1,
                                                            2,
                                                            false,
                                                            true
                                                        )}
                                                    >
                                                        <b className="customTableHeaderStyle">
                                                            Image From Site
                                                        </b>
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            2,
                                                            1,
                                                            5,
                                                            3
                                                        )}
                                                    >
                                                        {report.photo_1_url && (
                                                            <img
                                                                className="siteImg"
                                                                style={{
                                                                    width:
                                                                        "165px",
                                                                    height:
                                                                        "190px",
                                                                    margin:
                                                                        "auto",
                                                                }}
                                                                onClick={() => {
                                                                    checkRowCount = 2;
                                                                    this.setState(
                                                                        {
                                                                            imageModal: true,
                                                                        }
                                                                    );
                                                                }}
                                                                src={
                                                                    report.photo_1_url ===
                                                                        undefined ||
                                                                    report.photo_1_url ===
                                                                        null ||
                                                                    report.photo_1_url ===
                                                                        ""
                                                                        ? noImg
                                                                        : report.photo_1_url
                                                                }
                                                                alt="Site"
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            6,
                                                            1,
                                                            6,
                                                            2
                                                        )}
                                                    >
                                                        <b>Photo Timestamp</b>
                                                    </div>
                                                    <div
                                                        style={cstyle(
                                                            6,
                                                            2,
                                                            6,
                                                            2
                                                        )}
                                                    >
                                                        {
                                                            report.photo_1_timestamp
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                width: "100%",
                                                clear: "both",
                                            }}
                                        >
                                            <div
                                                style={gstyle(
                                                    5,
                                                    4,
                                                    null,
                                                    color
                                                )}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        2,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>
                                                        Manager/Supervisor
                                                        Signature
                                                    </b>
                                                </div>
                                                <div style={cstyle(2, 1, 4, 7)}>
                                                    <div
                                                        style={{
                                                            display: "none",
                                                        }}
                                                    >
                                                        {report.sig_3_url.includes(
                                                            "https:"
                                                        )
                                                            ? ""
                                                            : (offlineReference3 =
                                                                  "data:image/png;base64," +
                                                                  report.sig_1_url)}
                                                    </div>
                                                    {report.sig_3_url.includes(
                                                        "https:"
                                                    ) ? (
                                                        <img
                                                            style={{
                                                                width: "60%",
                                                                height: "auto",
                                                                margin: "auto",
                                                            }}
                                                            src={
                                                                report.sig_3_url ===
                                                                    undefined ||
                                                                report.sig_3_url ===
                                                                    null ||
                                                                report.sig_3_url ===
                                                                    ""
                                                                    ? noSig
                                                                    : report.sig_3_url
                                                            }
                                                            alt="No Signature Available"
                                                        />
                                                    ) : (
                                                        <img
                                                            style={{
                                                                width: "60%",
                                                                height: "auto",
                                                                margin: "auto",
                                                            }}
                                                            src={
                                                                report.sig_3_url ===
                                                                    undefined ||
                                                                report.sig_3_url ===
                                                                    null ||
                                                                report.sig_3_url ===
                                                                    ""
                                                                    ? noSig
                                                                    : offlineReference3
                                                            }
                                                            alt="No Signature Available"
                                                        />
                                                    )}
                                                </div>
                                                <div style={cstyle(5, 1, 5, 4)}>
                                                    <b>
                                                        Manager/Supervisor Name:
                                                    </b>
                                                    &nbsp;&nbsp;
                                                    {report.sig_3_name}
                                                </div>
                                                <div style={cstyle(5, 4, 5, 7)}>
                                                    <b>
                                                        Manager/Supervisor
                                                        Timestamp:
                                                    </b>
                                                    &nbsp;&nbsp;
                                                    {report.sig_3_timestamp}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={gstyle(4, 9, null)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Attached Photos</b>
                                            </div>
                                            {report.attached_photos &&
                                                this.renderPhotos(
                                                    report.attached_photos
                                                )}
                                        </div>
                                        <br />
                                        <div style={gstyle(4, 9, null)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>
                                                    Attached Inspector
                                                    Signatures
                                                </b>
                                            </div>
                                            {report.attached_inspector_signature &&
                                                this.renderSigs(
                                                    report.attached_inspector_signature
                                                )}
                                        </div>
                                        <br />
                                        <div style={gstyle(4, 9, null)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>
                                                    Attached Visitor Signatures
                                                </b>
                                            </div>
                                            {report.attached_visitor_signature &&
                                                this.renderSigs(
                                                    report.attached_visitor_signature
                                                )}
                                        </div>
                                        <br />
                                        <div style={gstyle(4, 9, null)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>
                                                    Attached Manager/Supervisor
                                                    Signatures
                                                </b>
                                            </div>
                                            {report.attached_manager_supervisor_signature &&
                                                this.renderSigs(
                                                    report.attached_manager_supervisor_signature
                                                )}
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            {this.state.editing &&
                                checkedit === "report-edit-jobpack" && (
                                    <Link
                                        to={this.props.location.pathname.replace(
                                            "report-edit-jobpack",
                                            "report-view"
                                        )}
                                    >
                                        <div>
                                            <ActionButton
                                                style={{ marginRight: 10 }}
                                                onClick={() => {
                                                    this.props.setReport(
                                                        this.state.report,
                                                        this.props.location
                                                            .pathname
                                                    );
                                                    
                                                    this.props.setActivity(
                                                        "update",
                                                        "report",
                                                        "vehicle_checklist"
                                                    );
                                                   
                                                }}
                                                variant="contained"
                                                color="primary"
                                            >
                                                Submit
                                            </ActionButton>
                                            <ActionButton
                                                color="secondary"
                                                variant="contained"
                                            >
                                                Cancel
                                            </ActionButton>
                                        </div>
                                    </Link>
                                )}

                            {!this.state.editing &&
                                checkedit === "report-view" && (
                                    <Link
                                        to={this.props.location.pathname.replace(
                                            "report-view",
                                            "report-edit-jobpack"
                                        )}
                                    >
                                        <ActionButton
                                            variant="contained"
                                            color="primary"
                                        >
                                            Edit
                                        </ActionButton>
                                    </Link>
                                )}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            {this.state.editing && checkedit === "report-edit" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit",
                                        "report-view-standalone"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                                this.props.setActivity(
                                                    "update",
                                                    "report",
                                                    "vehicle_checklist"
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                            {!this.state.editing &&
                                checkedit === "report-view-standalone" && (
                                    <Link
                                        to={this.props.location.pathname.replace(
                                            "report-view-standalone",
                                            "report-edit"
                                        )}
                                    >
                                        <ActionButton
                                            variant="contained"
                                            color="primary"
                                        >
                                            Edit
                                        </ActionButton>
                                    </Link>
                                )}
                        </div>

                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Site Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        report.photo_1_url === undefined ||
                                        report.photo_1_url === null ||
                                        report.photo_1_url === ""
                                            ? noImg
                                            : report.photo_1_url
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        checkRowCount = 2;
                                        this.setState({ imageModal: false });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </Print>
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, getJobPackReports, setActivity }
)(VehicleChecklist);
